import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { DefaultSharedItemProvider } from "./DefaultSharedItemProvider";
import { ISharedItemProvider } from "./ISharedItemProvider";

/** Factory class to get the appropriate shared item provider based on the linked item type. */
class SharedItemProviderFactory {
    private readonly defaultProvider = new DefaultSharedItemProvider();
    private readonly providers: { [key: number]: ISharedItemProvider } = {};

    /**
     * Get the shared item provider for the specified linked item type.
     * @param linkedItemType The linked item type.
     */
    public get(linkedItemType: PortalLinkedItemType): ISharedItemProvider {
        return this.providers[linkedItemType] ?? this.defaultProvider;
    }

    /**
     * Register a shared item provider for a specific linked item type.
     * @param linkedItemType The linked item type.
     * @param provider The shared item provider.
     */
    public registerProvider(linkedItemType: PortalLinkedItemType, provider: ISharedItemProvider): void {
        this.providers[linkedItemType] = provider;
    }

    /**
     * Unregister the shared item provider for a specific linked item type.
     * @param linkedItemType The linked item type.
     */
    public unregisterProvider(linkedItemType: PortalLinkedItemType): void {
        delete this.providers[linkedItemType];
    }
}

const sharedItemProviderFactory = new SharedItemProviderFactory();

export { SharedItemProviderFactory, sharedItemProviderFactory };
